import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CurrencyRupee = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 10H21.943C21.675 7.584 20.446 5.454 18.648 4H25C25.552 4 26 3.552 26 3C26 2.448 25.552 2 25 2H7C6.448 2 6 2.448 6 3C6 3.552 6.448 4 7 4H13C16.52 4 19.441 6.612 19.927 10H7C6.448 10 6 10.448 6 11C6 11.552 6.448 12 7 12H19.927C19.44 15.388 16.52 18 13 18H7C6.448 18 6 18.448 6 19C6 19.552 6.448 20 7 20H12.519C13.972 21.816 20.22 29.626 20.221 29.627C20.404 29.854 20.685 30 21 30C21.552 30 22 29.552 22 29C22 28.766 21.919 28.552 21.785 28.381C21.784 28.379 17.123 22.552 14.915 19.793C18.643 18.982 21.515 15.855 21.943 12H25C25.552 12 26 11.552 26 11C26 10.448 25.552 10 25 10V10Z" />
	</svg>
);

export default CurrencyRupee;
